module.exports = __webpack_public_path__ + "static/media/downLoad_icon.c71d206a.svg";